module.exports = __webpack_public_path__ + "static/media/msAzure.cdb1249d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/msAzure.jpg
// module id = 797
// module chunks = 5